import { useContext } from "react";
import { Button } from "components/button";
import { Header } from "components/header";
import AuthContext from "contexts/AuthContext";
import { useTranslation } from "react-i18next";
// import { LOCALE_NAME, STATE_NAME, COUNTRY_NAME } from "consts/query-params";
// import { useCurrentLocation } from "lib/utils";
// import TermsText from "../../components/terms-text";
import ScrollToTop from "components/scroll-to-top";
import { Footer } from "components/footer/footer";
// import ImpressumFooter from "components/footer-impressum";

export default function ReplayTermsConditionsPage() {
  //auth
  const { user } = useContext(AuthContext);

  //translation
  const { t } = useTranslation();

  // Get location settings
  // const { location: currentLocation } = useCurrentLocation();

  // const CtaButton = ({ className }) => {
  //   return (
  //     <Button
  //       href={`${t("urls.trade_in_weight")}`}
  //       queryParams={{
  //         [LOCALE_NAME]: currentLocation.locale,
  //         [STATE_NAME]: currentLocation.state,
  //         [COUNTRY_NAME]: currentLocation.country,
  //       }}
  //       className={className}
  //     >
  //       {t("landing.button_start_new")}
  //     </Button>
  //   );
  // };

  return (
    <div className="min-h-screen w-screen">
      <Header classNames="bg-yellow border-none">
        <div className="flex gap-large">
          {/* <CtaButton className="hidden md:block" /> */}
          <Button
            href={user ? `${t("urls.my_trade_ins")}` : `${t("urls.login")}`}
            variant="secondary"
          >
            {user
              ? t("landing.button_my_trade_ins")
              : t("landing.button_sign_in")}
          </Button>
        </div>
      </Header>
      <ScrollToTop />
      <div className="px-8 container mt-16 mb-16 max-w-prose mx-auto min-h-[calc(100vh-81px)]">
        <div className="max-w-prose mx-auto">
          <h1 className="text-3xl font-bold mb-8">
            <div className="mb-4">LEGO Replay</div>
            Terms & Conditions
          </h1>
          <p className="mb-6 italic">Last Modified: 18 March 2025</p>

          <h2 className="text-2xl font-semibold mb-4">
            Why are these Terms and Conditions important to me?
          </h2>
          <p className="mb-6">
            These Terms and Conditions are important to you because they apply
            if you donate your LEGO® bricks to us as part of the LEGO® Replay
            Program. We strongly recommend that you read these Terms and
            Conditions carefully before entering into a contract with us.
          </p>

          <h2 className="text-2xl font-semibold mb-4">
            How are these Terms and Conditions structured?
          </h2>
          <p className="mb-6">
            We have drafted these Terms and Conditions in a format of questions
            and answers in order to make it easier for you to understand them.
            All questions below are drafted from the perspective of you as the
            donator. Therefore, within the questions, you will be referred to as
            “I,” “my,” or “me.” Within the answers, you will be referred to as
            "you," "your," or “donator.”
          </p>
          <p className="mb-6">
            In these Terms and Conditions, you will find the answers to the
            following questions:
          </p>
          <ul className="list-disc pl-6 mb-6">
            <li>When do these Terms and Conditions apply?</li>
            <li>What is the LEGO® Replay program, and how does it work?</li>
            <li>What are we liable for?</li>
            <li>What law applies to these Terms and Conditions?</li>
          </ul>

          <h2 className="text-2xl font-semibold mb-4">
            1. When do these Terms and Conditions apply?
          </h2>
          <h3 className="text-xl font-semibold mb-2">
            1.1. Who do these Terms and Conditions apply to?
          </h3>
          <p className="mb-6">
            These Terms and Conditions apply to any individual consumer that
            chooses to donate LEGO® bricks to us within the United States. To
            participate in the LEGO Replay program, you must be at least 18
            years old. Additionally, as a condition of participating in the
            program and entering into this contract, you must be the owner of
            the LEGO bricks that are the subject of the donation and/or have the
            legal right to transfer title of these bricks to us. Please note
            that this program is only available to those located in the United
            States, including Alaska and Hawaii.
          </p>

          <h3 className="text-xl font-semibold mb-2">
            1.2. Can I also donate my LEGO® bricks if I act in my capacity as a
            business?
          </h3>
          <p className="mb-6">
            If you are a business wanting to donate LEGO® bricks to us, please
            reach out to LEGO Customer Service at 1-844-903-5346.
          </p>

          <h3 className="text-xl font-semibold mb-2">
            1.3. When do I enter into this contract with you?
          </h3>
          <p className="mb-6">
            Once you complete the application form for donation, you are
            required to accept these terms and conditions.
          </p>

          <h3 className="text-xl font-semibold mb-2">
            1.4. What kind of LEGO® bricks are eligible?
          </h3>
          <p className="mb-6">
            We specifically accept LEGO® system bricks, LEGO®DUPLO®, LEGO®
            Technic™ Bricks, LEGO® Minifigures, LEGO® Mini-dolls and
            baseplates that have been used in the past. Therefore, we do not
            expect your LEGO® bricks to be in mint condition. However, we
            reserve the right to remove and recycle, where possible, any LEGO®
            bricks if they are not in a reasonable condition. LEGO® bricks are
            not in a reasonable condition if one of our staff members in their
            discretion determines that (a) an appreciable number of the bricks
            are cracked and/or significantly worn, or (b) the bricks may pose a
            health or safety risk.
          </p>

          <h3 className="text-xl font-semibold mb-2">
            1.5. What items are ineligible?
          </h3>
          <p className="mb-6">
            Currently, we are not able to accept the following bricks or
            elements:
          </p>
          <ul className="list-disc pl-6 mb-6">
            <li>Third-party bricks, elements, or toys</li>
            <li>
              LEGO® brand sets that are already fully or partially built
              including LEGO® Mindstorms™
            </li>
            <li>
              Batteries or electronic components including those which are
              LEGO® branded
            </li>
            <li>
              LEGO® brand and third-party branded merchandise and all non-brick
              items including apparel, storage containers, and backpacks.
            </li>
            <li>Building instructions or packaging</li>
          </ul>
          <p className="mb-6">
            Therefore, we strongly encourage you to remove any of the listed
            items before packaging your brick donation and only include
            disassembled LEGO® bricks and elements. Any ineligible bricks,
            elements, or other items will be removed and recycled in accordance
            with local practices and laws, as part of our commitment to
            circularity, and will not be returned to you. We reserve the right
            to change the list of ineligible items at any time and for any
            reason in our sole discretion.
          </p>

          <h3 className="text-xl font-semibold mb-2">
            1.6. When do you become the owner of the bricks (i.e., transfer of
            title)?
          </h3>
          <p className="mb-6">
            The title to the LEGO® bricks and any other contents of your
            package shall transfer to us upon receipt of your package by the
            shipping carrier. Once the package ships and is on its way to us,
            you shall not retain any title to the bricks, or any other items
            included in the package thereafter. Please note that we will not
            return any bricks or other elements or items that we deem in our
            discretion are ineligible. We will retain title to these mailed-in
            ineligible items and will not return them to you. Thus, we encourage
            you to carefully review the contents of your package before
            shipment.
          </p>

          <h3 className="text-xl font-semibold mb-2">
            1.7. Can I get paid for my LEGO® bricks?
          </h3>
          <p className="mb-6">
            The LEGO® Replay program is a voluntary donation program, and no
            remuneration is offered for the donations, nor any tax related
            documentation.
          </p>

          <h2 className="text-2xl font-semibold mb-4">
            2. What is the LEGO® Replay program, and how does it work?
          </h2>
          <h3 className="text-xl font-semibold mb-2">
            2.1. What is the LEGO® Replay program?
          </h3>
          <p className="mb-6">
            We’re looking for ways to keep LEGO® bricks in play. Donate your
            bricks and help us explore new options for passing on the joy of
            play. The Replay program is an easy and sustainable way to share the
            joy of play with children who may not have access to LEGO® bricks
            for play and learning.
          </p>

          <h3 className="text-xl font-semibold mb-2">
            2.2. Where can I donate my LEGO® bricks?
          </h3>
          <p className="mb-6">
            Download a prepaid shipping label from www.lego.com/replay to get
            started. Pack up your used, qualifying bricks, attach the provided
            label, and drop your package at your local UPS location. We will
            take care of the rest to donate.
          </p>

          <h3 className="text-xl font-semibold mb-2">
            2.3. What happens with the bricks I am donating?
          </h3>
          <p className="mb-6">
            Donated LEGO® bricks are sorted, cleaned, and packed into LEGO®
            Replay boxes that are distributed to LEGO’s community partner
            network. We reserve the right to combine brick donations with used
            or new LEGO® brand bricks as needed to uphold a strong play quality
            experience and meet Replay commitments with charity partners.
          </p>

          <h3 className="text-xl font-semibold mb-2">
            2.4. Who benefits from the LEGO® Replay program?
          </h3>
          <p className="mb-6">
            Currently, LEGO Replay play boxes are distributed to Title I
            community teachers and program leads via the First Book membership
            network across the US.
          </p>

          <h2 className="text-2xl font-semibold mb-4">
            3. What are we liable for?
          </h2>
          <p className="mb-6 font-bold italic">
            We are only liable for loss or damage due to gross negligence. In no
            event will we be liable for any direct or indirect, incidental,
            statutory, exemplary, punitive, special, or consequential damages as
            a result of any claims, whether arising under tort, breach of
            contract, strict liability, or otherwise, related to your
            participation in the LEGO® Replay program. We disclaim any and all
            warranties to the fullest extent permissible under the law.
          </p>

          <h2 className="text-2xl font-semibold mb-4">
            4. What law applies to these Terms and Conditions?
          </h2>
          <p className="mb-6">
            These Terms and Conditions and all matters arising out of or
            relating to these Terms and Conditions are governed by, and
            construed in accordance with, the laws of the State of New York,
            United States of America, without regard to the conflict of law
            provisions thereof to the extent such principles or rules would
            require or permit the application of the laws or any jurisdiction
            other than those of the State of New York. As you are contracting as
            a consumer, this will not affect your statutory rights. The UN
            Convention on Contracts for the International Sale of Goods shall
            not apply to this Agreement.
          </p>
        </div>
      </div>
      <Footer />
      {/* <ImpressumFooter /> */}
    </div>
  );
}
